import { Button, Stack } from "components";
import Dots from "./Dots";
import Page from "./Page";
import createPages from "./createPages";

interface PaginationProps {
  current: number;
  count: number;
  onChange(page: number): void;
}

const Pagination: React.FC<PaginationProps> = ({
  current,
  count,
  onChange,
}) => {
  const pages = createPages(current, count);
  const canNext = current + 1 <= count;
  const handleNext = canNext ? () => onChange(current + 1) : undefined;

  return (
    <Stack placeContent="flex-end">
      {pages.map((page, index) => {
        if (page === "...") {
          return <Dots key={index} />;
        } else {
          return (
            <Page
              key={index}
              number={page}
              active={current === page}
              onClick={onChange}
            />
          );
        }
      })}
      <Button
        filled
        size="small"
        onClick={handleNext}
        disabled={!handleNext}
        style={{ minWidth: "unset" }}
      >
        Next
      </Button>
    </Stack>
  );
};

export { Pagination };
